/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ maxCps: NonNullable<unknown> }} Error_Nav_Cps_ExceedsInputs */



/**
* | output |
* | --- |
* | "CPS exceeds maximum set rate ({maxCps})." |
*
* @param {Error_Nav_Cps_ExceedsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_cps_exceeds = /** @type {((inputs: Error_Nav_Cps_ExceedsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Cps_ExceedsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Le CPS depasse le taux maximal defini (${i?.maxCps}).`)
	if (locale === "de") return /** @type {LocalizedString} */ (`CPS überschreitet die maximal eingestellte Rate (${i?.maxCps}).`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Il CPS supera la velocità massima impostata (${i?.maxCps}).`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`CPS превышает максимально установленную скорость (${i?.maxCps}).`)
	if (locale === "es") return /** @type {LocalizedString} */ (`CPS excede la velocidad máxima establecida (${i?.maxCps}).`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`CPS 超过最大设定值 (${i?.maxCps})。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`CPS が最大設定レート (${i?.maxCps}) を超えています。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`सीपीएस अधिकतम निर्धारित दर (${i?.maxCps}) से अधिक है।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`CPS excede a taxa máxima definida (${i?.maxCps}).`)
	return /** @type {LocalizedString} */ (`CPS exceeds maximum set rate (${i?.maxCps}).`)
});